'use strict';
module.exports = {
    initEvents: function () {
        $('#qf-modal-error-payment').modal('show');
    }
};
